import { useContext, useEffect } from 'react';
import { connect } from 'react-redux';
import { WardrobeHeightContext } from '../../contexts/WardrobeHeightContext';
import { reactLocalStorage } from 'reactjs-localstorage';

const SetupComponent = props => {
  const { children, dimensions } = props;
  const { wardrobeHeight, setWardrobeHeight } = useContext(WardrobeHeightContext);

  useEffect(() => {
    if (typeof wardrobeHeight !== 'number' && !!dimensions) {
      const savedHeight = reactLocalStorage.get('wardrobeHeight');
      if (savedHeight) {
        setWardrobeHeight(parseInt(savedHeight));
      } else {
        setWardrobeHeight(dimensions.height[0]);
      }
    }
    /* eslint-disable-next-line */
  }, []);

  return children;
};

const mapStateToProps = state => {
  return {
    wardrobeHulls: state.products.wardrobeHulls,
    cornerHulls66x66: state.products.cornerHulls66x66,
    cornerHulls45x66: state.products.cornerHulls45x66,
    cornerHulls66x45: state.products.cornerHulls66x45,
  };
};

export default connect(mapStateToProps, null)(SetupComponent);
